module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[107]106.5a6038f.woff2";